module.exports = new __parcel__URL__("Druideskill_22.c87a8919.png").toString();